import React from 'react';

import MainTemplate from 'pages/templates/MainTemplate';

const MediaScriptManag = () => {
  return (
    <MainTemplate>
      <h2>매체 스크립트 관리</h2>
    </MainTemplate>
  );
};

export default MediaScriptManag;
